var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{class:_vm.b('container')},[(_vm.$apollo.queries.categories.loading || _vm.categoriesError || !_vm.categories)?_c('loading-wrapper',{attrs:{"error":_vm.categoriesError},on:{"retry":_vm.onRetryCategoriesFetch}}):_c('categories',{attrs:{"categories":_vm.categories || []}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }